import { onDocumentReady } from "@story/story_assets";

// *************************************************************************
// Animation
// *************************************************************************

// Hide page when click to target
document.addEventSelectorListener("click", "a[href]", function(event, target) {
	var href = target.getAttribute("href");
	var linkTarget = target.getAttribute("target");
	var fancybox = target.getAttribute("data-gallery") || target.getAttribute("data-custom-gallery") || target.getAttribute("data-modal") || target.getAttribute("data-remote");
	if (href.startsWith("mailto:") || href.startsWith("tel:") || href.indexOf("#") !== -1 || linkTarget || fancybox) {
		return;
	}

	var pageContainer = document.querySelector(".page-container");
	if (!pageContainer) {
		return;
	}

	event.preventDefault();
	pageContainer.classList.add("hidden");

	setTimeout(function() {
		window.location = href;
	}, 500);
});

// Reset animation, when back button is pressed
window.addEventListener("pageshow", function(event) {
	onDocumentReady(function() {
		var element = document.querySelector(".page-container");
		if (element) {
			element.classList.remove("hidden");
		}
	});

	var element = document.querySelector(".page-container");
	if (element) {
		element.classList.remove("hidden");
	}
});
